import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { initializeAuthSession } from "./store/authSlice";
import "./App.css";

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ProductPage from './pages/ProductPage';
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminShippingPanel from "./pages/admin/AdminShippingPanel";
import LoginRegisterModal from './components/LoginRegisterModal';
import AddProduct from "./pages/admin/AddProduct";
import ShopPage from "./pages/ShopPage";
import Myorder from "./pages/Myorder";
import OrderSuccessPage from "./pages/OrderSuccessPage";
import AdminOrdersPage from "./pages/admin/AdminOrdersPage";
import AdminProductsPage from "./pages/admin/AdminProductsPage";
import EditProduct from "./pages/admin/EditProduct";
import AdminCoupon from "./pages/admin/AdminCoupon";
import Blog from "./pages/blog";
import BlogDetail from "./pages/blog-detail";
import TermsConditions from "./pages/teams";
import ScrollToTop from "./components/ScrollToTop";
import AdminBlog from "./pages/admin/Adminblog";
import AdminSidebar from "./pages/admin/AdminSidebar";
import AdminCategories from "./pages/admin/AdminCategories";
import Myorderdetalis from "./pages/myorder-details";
import AdminHomePageManage from "./pages/admin/AdminHomePageManage";
import AdminMediaGallery from "./pages/admin/AdminMediaGallery";
import FlipkartAdmin from "./pages/admin/FlipkartAdmin";


const AdminLayout = () => {

  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  return (
    // अगर साइडबार क्लोज्ड है तो .collapsed क्लास लग जाएगी, जिससे margin-left: 0; एक्टिव होगा
    <div className={`main-content ${!isSidebarOpen ? "collapsed" : ""}`}>
     
      <AdminSidebar isOpen={isSidebarOpen} toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
      

      <div className="admin-layout">
        <Outlet />
      </div>
    </div>
  );
};

const App = () => {
  const dispatch = useDispatch();
  const { user, token, globalAuthLoading } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(initializeAuthSession());
  }, [dispatch]);

  if (globalAuthLoading) {
    return (
      <div className="app-core-initialization-splash">
        <div className="spinner-element"></div>
        <p>Initializing Secure Session Runtimes...</p>
      </div>
    );
  }

  const AdminProtectedRoute = ({ children }) => {
    if (!token || !user || user.role !== "admin") {
      return <Navigate to="/" replace />;
    }
    return children ? children : <Outlet />;
  };
 
  const WebLayout = () => {
    return (
      <>
        <Navbar />
        <main style={{minHeight:'100vh'}} className="ecommerce-main">
          <Outlet />
        </main>
        <Footer />
      </>
    );
  };
  const UserProtectedRoute = ({ children }) => {
    if (!token) {
      return <Navigate to="/" replace state={{ triggerLogin: true }} />;
    }
    return children;
  };

  return (
    <Router>
      <div className="application-viewport-wrapper">
        <ScrollToTop />
      

        <main>
          <Routes>
       <Route element={<WebLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/product/:slug" element={<ProductPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/blog-detail/:title" element={<BlogDetail />} />
            <Route path="/terms" element={<TermsConditions />} />

            {/* प्रोटेक्टेड यूजर राउट्स */}
            
             <Route path="/myorder-details" element={<UserProtectedRoute><Myorderdetalis/></UserProtectedRoute>} />
            <Route path="/myorder" element={<UserProtectedRoute><Myorder /></UserProtectedRoute>} />
            <Route path="/checkout" element={<UserProtectedRoute><CheckoutPage /></UserProtectedRoute>} />
            <Route path="/order-success" element={<UserProtectedRoute><OrderSuccessPage /></UserProtectedRoute>} />
          </Route>


            {/* ⚙️ एडमिन प्रोटेक्टेड रूट्स (आपके कस्टम CSS लेआउट के साथ) */}
            <Route element={<AdminProtectedRoute><AdminLayout /></AdminProtectedRoute>}>
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/admin/shipping" element={<AdminShippingPanel />} />
              <Route path="/admin/productlist/addproduct" element={<AddProduct />} />
              <Route path="/admin/orders" element={<AdminOrdersPage />} />
              <Route path="/admin/productlist" element={<AdminProductsPage />} />
              <Route path="/admin/editproduct/:id" element={<EditProduct />} />
              <Route path="/admin/coupon" element={<AdminCoupon />} />
              <Route path="/admin/blog" element={<AdminBlog />} />
               <Route path="/admin/Categories" element={<AdminCategories />} />
                <Route path="/admin/homemange" element={<AdminHomePageManage />} />
                  <Route path="/admin/gallery" element={<AdminMediaGallery />} />
                    <Route path="/admin/flipkart" element={<FlipkartAdmin />} />
            
            </Route>

            {/* 🔄 वाइल्डकार्ड रीडायरेक्ट */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>

     
        <LoginRegisterModal />
      </div>
    </Router>
  );
};

export default App;